import { ComponentProps, forwardRef } from 'react'
import styles from '../field.module.scss'

interface InputProps extends ComponentProps<'input'> {
  appearance?: 'error' | 'neutral'
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, appearance, ...props }, ref) => (
    <input
      ref={ref}
      {...props}
      className={[
        styles.field,
        appearance && styles[appearance],
        className,
      ].join(' ')}
    />
  ),
)

Input.displayName = 'Input'

export default Input
